<!-- PLC子设备配置 -->
<template>
    <div class='container'>
        <div class="handleForm">
            <el-form
                ref="form"
                :inline="true"
                :model="form"
                label-width="80px">
                <el-form-item>
                    <el-button
                        type="primary"
                        size="small"
                        icon="el-icon-puls"
                        @click="handleAdd"
                    >增加</el-button>
                    <el-button
                        type="primary"
                        size="small"
                        icon="el-icon-puls"
                        @click="handleToSet"
                    >PLC设置</el-button>
                    <el-button
                        type="primary"
                        size="small"
                        icon="el-icon-puls"
                        @click="handleExport"
                    >导出</el-button>
                    <el-button
                        type="primary"
                        size="small"
                        icon="el-icon-puls"
                        @click="handleExportMode"
                    >下载模板</el-button>
                </el-form-item>
                <el-form-item>
                    <el-upload
                        :action="UploadUrl" 
                        :show-file-list="false" 
                        accept="application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" 
                        :on-success="handleAvatarSuccess" 
                        :on-progress="uploadVideoProcess"
                        :headers="headers"
                        name="image"
                        :before-upload="beforeAvatarUpload"
                        style="display: inline-block;">
                        <el-button size="small" type="primary" style="margin: 0 10px;">导入变量 <span v-if="videoUploadPercent>0 && videoUploadPercent<100">{{videoUploadPercent+"%"}}</span></el-button>
                    </el-upload>
                </el-form-item>
            </el-form>
        </div>
        <lb-table v-loading="loading"
            :column="tableData.column"
            :data="tableData.data"
            :height="maxHeight"
            stripe
            pagination
            layout="total, sizes, prev, pager, next, jumper"
            :page-sizes="[10, 20, 50, 100]"
            :current-page.sync="page_num"
            :total="total"
            :page-size="page_sum"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange">
        </lb-table>

        <!-- 新增+编辑弹框 -->
        <el-dialog :title="title" width="80%" :visible.sync="dialogFormVisible" @before-close="handleCloseDialog">
            <el-form :model="addForm" label-width="100px" :rules="addFormRule" ref="addForm">
                <el-form-item label="名称" prop="plc_terminal_name">
                    <el-input v-model="addForm.plc_terminal_name" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="设备类型" prop="plc_terminal_type">
                    <el-select style="width:100%;" v-model="addForm.plc_terminal_type" placeholder="请选择设备类型">
                        <el-option
                            v-for="item in deviceType"
                            :key="item.code"
                            :label="item.name"
                            :value="item.code">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="状态地址" prop="plc_power_on_addr">
                    <el-select  style="width:100%;" v-model="addForm.plc_power_on_addr" filterable placeholder="请选择参数地址">
                        <el-option
                            v-for="item in varData"
                            :key="item.value"
                            :label="item.var_name+' : '+item.var_Initial_addr"
                            :value="item.var_Initial_addr">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="状态值" prop="plc_power_on_value">
                    <el-input v-model.number="addForm.plc_power_on_value" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="故障地址" prop="plc_error_addr">
                    <el-select  style="width:100%;" v-model="addForm.plc_error_addr" filterable placeholder="请选择参数地址">
                        <el-option
                            v-for="item in varData"
                            :key="item.value"
                            :label="item.var_name+' : '+item.var_Initial_addr"
                            :value="item.var_Initial_addr">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="故障值" prop="plc_error_value">
                    <el-input v-model.number="addForm.plc_error_value" autocomplete="off"></el-input>
                </el-form-item>
                <!-- 参数子设备 -->
                <div>
                    <template v-for="(domain, index) in addForm.plc_addrs">
                        <el-row :gutter="5" :key="index">
                            <el-col :span="4">
                                <el-form-item
                                    size="mini"
                                    label="参数"
                                    label-width="60px"
                                    :prop="'plc_addrs.' + index + '.addr'"
                                    :rules="{
                                        required: true, message: '地址不能为空', trigger: 'blur'
                                    }">
                                    <el-select v-model="domain.addr" filterable placeholder="请选择参数">
                                        <el-option
                                            v-for="item in varData"
                                            :key="item.value"
                                            :label="item.var_name+' : '+item.var_Initial_addr"
                                            :value="item.var_Initial_addr">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="3">
                                <el-form-item
                                    size="mini"
                                    label="名称"
                                    label-width="60px"
                                    :key="domain.key"
                                    :prop="'plc_addrs.' + index + '.name'"
                                    :rules="{
                                        required: true, message: 'name不能为空', trigger: 'blur'
                                    }">
                                        <el-input v-model="domain.name" placeholder="name"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="3">
                                <el-form-item
                                     size="mini"
                                    label="类型"
                                    label-width="60px"
                                    :key="domain.key"
                                    :prop="'plc_addrs.' + index + '.type'"
                                    :rules="{
                                        required: true, message: '类型不能为空', trigger: 'blur'
                                    }">
                                    <el-select v-model="domain.type" placeholder="请选择类型">
                                        <el-option
                                            v-for="item in argType"
                                            :key="item.code"
                                            :label="item.name"
                                            :value="item.code">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
							<el-col :span="5">
							    <el-form-item
							         size="mini"
							        label="高低位互换"
							        label-width="140px"
							        :key="domain.key"
							        :prop="'plc_addrs.' + index + '.is_swap'"
							        :rules="{
							            required: true, message: '高低位互换不能为空', trigger: 'blur'
							        }">
							        <el-select v-model="domain.is_swap" placeholder="请选择">
							            <el-option
							                v-for="item in swaplist"
							                :key="item.idx"
							                :label="item.name"
							                :value="item.code">
							            </el-option>
							        </el-select>
							    </el-form-item>
							</el-col>
                            <el-col :span="3">
                                <el-form-item
                                    size="mini"
                                    label="bytes"
                                    label-width="60px"
                                    :key="domain.key"
                                    :prop="'plc_addrs.' + index + '.bytes'"
                                    :rules="{
                                        required: true, message: 'bytes不能为空', trigger: 'blur'
                                    }">
                                     <el-input v-model.number="domain.bytes" placeholder="bytes"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="2">
                                <el-form-item
                                    label-width="0"
                                    size="mini"
                                    :key="domain.key"
                                    :prop="'plc_addrs.' + index + '.value_type'"
                                    :rules="{
                                        required: true, message: '类型不能为空', trigger: 'blur'
                                    }">
                                    <el-select v-model="domain.value_type" placeholder="请选择类型">
                                        <el-option label="float" value="float"></el-option>
                                        <el-option label="int" value="int"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="2">
                                <el-form-item
                                    size="mini"
                                    label-width="0"
                                    :key="domain.key"
                                    :prop="'plc_addrs.' + index + '.last_accumulated_value'">
                                     <el-input v-model.number="domain.last_accumulated_value" placeholder="累计起始值"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="1">
                                <el-button  size="mini" icon="el-icon-delete" type="danger"  @click.prevent="removeDomain(domain)"></el-button>
                            </el-col>
                        </el-row>
                    </template>
                    <el-button @click="addDomain">新增参数</el-button>
                </div>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="handleSave">确 定</el-button>
            </div>
        </el-dialog>

<!-- 新增+编辑弹框 -->
        <el-dialog title="PLC 设置" width="80%" :visible.sync="dialogFormVisible1">
            <el-form :model="addPLCForm" label-width="100px" :rules="addPLCFormRule" ref="addPLCForm">
                <!-- 参数子设备 -->
                <div>
                    <template v-for="(domain, index) in addPLCForm.plc_addrs">
                        <el-row :gutter="4" :key="index">
                            <el-col :span="4">
                                <el-form-item
                                    size="mini"
                                    label="参数"
                                    label-width="60px"
                                    :prop="'plc_addrs.' + index + '.addr'"
                                    :rules="{
                                        required: true, message: '地址不能为空', trigger: 'blur'
                                    }">
                                    <el-select v-model="domain.addr" filterable placeholder="请选择参数">
                                        <el-option
                                            v-for="item in varData"
                                            :key="item.value"
                                            :label="item.var_name+' : '+item.var_Initial_addr"
                                            :value="item.var_Initial_addr">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="3">
                                <el-form-item
                                    size="mini"
                                    label="名称"
                                    label-width="60px"
                                    :key="domain.key"
                                    :prop="'plc_addrs.' + index + '.name'"
                                    :rules="{
                                        required: true, message: 'name不能为空', trigger: 'blur'
                                    }">
                                        <el-input v-model="domain.name" placeholder="name"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="4">
                                <el-form-item
                                     size="mini"
                                    label="类型"
                                    label-width="60px"
                                    :key="domain.key"
                                    :prop="'plc_addrs.' + index + '.type'"
                                    :rules="{
                                        required: true, message: '类型不能为空', trigger: 'blur'
                                    }">
                                    <el-select v-model="domain.type" placeholder="请选择类型">
                                        <el-option
                                            v-for="item in argType"
                                            :key="item.code"
                                            :label="item.name"
                                            :value="item.code">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
							<el-col :span="5">
							    <el-form-item
							         size="mini"
							        label="高低位互换"
							        label-width="140px"
							        :key="domain.key"
							        :prop="'plc_addrs.' + index + '.is_swap'"
							        :rules="{
							            required: true, message: '高低位互换不能为空', trigger: 'blur'
							        }">
							        <el-select v-model="domain.is_swap" placeholder="请选择" @change="getswap">
							            <el-option
							                v-for="item in swaplist"
							                :key="item.code"
							                :label="item.name"
							                :value="item.code">
							            </el-option>
							        </el-select>
							    </el-form-item>
							</el-col>
                            <el-col :span="3">
                                <el-form-item
                                    size="mini"
                                    label="bytes"
                                    label-width="60px"
                                    :key="domain.key"
                                    :prop="'plc_addrs.' + index + '.bytes'"
                                    :rules="{
                                        required: true, message: 'bytes不能为空', trigger: 'blur'
                                    }">
                                     <el-input v-model.number="domain.bytes" placeholder="bytes"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="2">
                                <el-form-item
                                    label-width="0"
                                    size="mini"
                                    :key="domain.key"
                                    :prop="'plc_addrs.' + index + '.value_type'"
                                    :rules="{
                                        required: true, message: '类型不能为空', trigger: 'blur'
                                    }">
                                    <el-select v-model="domain.value_type" placeholder="请选择类型">
                                        <el-option label="float" value="float"></el-option>
                                        <el-option label="int" value="int"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="2">
                                <el-form-item
                                    size="mini"
                                    label-width="0"
                                    :key="domain.key"
                                    :prop="'plc_addrs.' + index + '.last_accumulated_value'">
                                     <el-input v-model.number="domain.last_accumulated_value" placeholder="累计起始值"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="1">
                                <el-button  size="mini" icon="el-icon-delete" type="danger"  @click.prevent="removeDomain1(domain)"></el-button>
                            </el-col>
                        </el-row>
                    </template>
                    <el-button @click="addDomain1">新增参数</el-button>
                </div>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible1 = false">取 消</el-button>
                <el-button type="primary" @click="handleSave1">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import Storage from '@/utils/storage'
import config from '@/config'
import Service from '@/api/Service'
import LbTable from '@/components/lb-table/lb-table'
import { getMaxHeigth, $Alert } from '@/utils/utils'

const defaultForm = {
    plc_terminal_name: '',
    plc_addrs: [],
    plc_power_on_addr: '',
    plc_power_on_value: '',
    plc_error_addr: '',
    plc_error_value: '',
}
export default {
    name:  'plcterminalset',
    data() {
        return {
            oid: '',
			swaplist:[
				{
					code:true,
					name:"true"
				},
				{
					code:false,
					name:"false"
				},
			],
            form: {},
            tableData: {
                column: [
                    {
                        type: 'expand',
                        render: (h, props) => {
                        return  (
                            <el-form label-position="left"
                                inline 
                                class="demo-table-expand">
                                {props.row.plc_addrs.map(v=>{
                                    return (
                                        <div>
                                            <el-form-item label="参数">
                                            <span>{ v.addr }</span>
                                            </el-form-item>
                                            <el-form-item label="名称">
                                                <span>{ v.name }</span>
                                            </el-form-item>
                                            <el-form-item label="类型">
                                                <span>{ v.type }</span>
                                            </el-form-item>
											<el-form-item label="高低位互换">
											    <span>{ v.is_swap }</span>
											</el-form-item>
                                            <el-form-item label="bytes">
                                                <span>{ v.bytes }</span>
                                            </el-form-item>
                                        </div>
                                    )
                                })} 
                            </el-form>
                        )
                        }
                    },
                    {
                        type: 'index',
                        align: 'center'
                    },
                    {
                        prop: 'plc_terminal_name',
                        label: '名称',
                        sortable: true,
                    },
                    {
                        prop: 'plc_power_on_addr',
                        label: '开机地址',
                        sortable: true,
                    },
                    {
                        prop: 'plc_power_on_value',
                        label: '开机值'
                    },
                    {
                        prop: 'plc_error_addr',
                        label: '故障地址',
                    },
                    {
                        prop: 'plc_error_value',
                        label: '故障值'
                    },
                    {
                        label: '操作',
                        width: '180px',
                        render: (h, scope) => {
                        return (
                            <div>
                            <el-button
                                size="mini"
                                type="primary"
                                icon="el-icon-edit"
                                onClick={ () => { this.handleEdit(scope.$index, scope.row) } }>编辑</el-button>
                            <el-button
                                size="mini"
                                type="danger"
                                icon="el-icon-delete"
                                onClick={ () => { this.handleDelete(scope.$index, scope.row) } }>删除</el-button>
                            </div>
                        )
                        }					
                    }
                ],
                data: []
            },
            loading: false,
            maxHeight: 500,
            total: 0,
            page_num: 1,
            page_sum: 10,

            deviceType: [],
            argType: [],

            dialogFormVisible: false,
            title: '编辑',
            addForm: JSON.parse(JSON.stringify(defaultForm)),
            addFormRule: {
                plc_terminal_name: [
                    { required: true, message: '请输入名称', trigger: 'blur' }
                ],
                plc_power_on_addr: [
                    { required: true, message: '请选择开机地址', trigger: 'change' }
                ],
                plc_power_on_value: [
                    { required: true, message: '请输入开机值', trigger: 'blur' }
                ],
                plc_error_addr: [
                    { required: true, message: '请选择故障地址', trigger: 'change' }
                ],
                plc_error_value: [
                    { required: true, message: '请输入故障值', trigger: 'blur' }
                ],
                plc_terminal_type: [
                    { required: true, message: '请选择类型', trigger: 'change' }
                ]
            },

            dialogFormVisible1: false,
            addPLCForm: {
                plc_addrs: [],
            },
            addPLCFormRule: {},

            // 上传
            UploadUrl: config.UPLOAD_URL,
            videoUploadPercent: 0,

        };
    },

    components: { LbTable },
    mounted() {
        this.$nextTick(()=>{
            this.maxHeight = getMaxHeigth();
        })
    },

    computed: {
        ...mapGetters(["machine"]),
        varData() {
            return this.machine.var_config
        },
        headers() {
            let token = Storage.get('token');
            if (token) {
                return { Authorization: token.token };
            }else{
                return {}
            }
        }
    },

    async created() {
        // 表计ID
        this.oid = this.$route.params.id
        await this.getData()
        await this.getDeviceType()
        await this.getPlcConfig()
        await this.getArgType()
		
    },

    methods: {
        async getData() {
            let params = {
                terminal_id: this.oid,
                page_num: this.page_num,
                page_sum: this.page_sum,
            }
            let res = await Service.getPlcTerminal(params)
            if(res.list && res.list.length>0) {
                this.tableData.data = res.list
                this.total = res.total
            }
        },
		getswap(v){
			// this.defaultForm.plc_addrs.is_swap
		},
        async getDeviceType() {
            let res = await Service.getTypeCodeSystemDic({type_code: 'plc_terminal_type'})
            res = res === 'success' ? [] : res
            if(res.length>0) {
                this.deviceType = res
            }
        },
        async getArgType() {
            let res = await Service.getTypeCodeSystemDic({type_code: 'plc_addr_type'})
            res = res === 'success' ? [] : res
            if(res.length>0) {
                this.argType = res
            }
        },
        // 获取变量列表
        async getPlcConfig() {
			console.log("i do", this.oid)
            let terminal_id = this.oid
            // if(this.machine.var_config.length>0){
            //     return
            // }
            
            if(terminal_id === '') return
            let params = {
                terminal_id,
                page_num: 1,
                page_sum: 1000,
            }
            
            let res = await Service.getPlcConfig(params);
            if(res) {
                let list = res.list === null ? [] : res.list;
                this.$store.dispatch('setVarConfig', list);
            }
        },
        handleSave() {
            this.$refs['addForm'].validate(async (valid) => {
                if (valid) {
                    this.addForm.terminal_id = this.oid
					this.addForm.plc_addrs[0].is_swap = JSON.parse(this.addForm.plc_addrs[0].is_swap)
                    let plc_addrs = JSON.stringify(this.addForm.plc_addrs)
                    let params = Object.assign({}, this.addForm, {plc_addrs})
                    let res
                    if(this.addForm.oid) {
                        // 编辑
                        res = await Service.editPlcTerminal(params)
                    }else{
                        // 新增
                        res = await Service.addPlcTerminal(params)
                    }
                    if(res) {
                        this.$message({
                            type: 'success',
                            message: '操作成功!'
                        });
                        this.dialogFormVisible = false;
                        this.getData();
                    }
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        handleAdd() {
            this.title = "新增"
            this.addForm = JSON.parse(JSON.stringify(defaultForm))
            this.dialogFormVisible = true;
        },
        handleEdit (index, row) {
            this.title = "编辑"
            this.addForm = Object.assign({}, row);
            this.dialogFormVisible = true;
        },
        handleCloseDialog() {
            this.$refs['addForm'].resetFields()
        },
        handleDelete (index, row) {
            let { oid } = row
            $Alert(`是否删除 ${row.plc_terminal_name}`).then( async (bool)=>{
                if(bool){
                    let res = await Service.delPlcTerminal({ oid });
                    if(res) {
                        this.$message({
                            type: 'success',
                            message: '操作成功!'
                        });
                        this.getData();
                    }
                }
            });
        },
        //   获取数据
        handleSizeChange (val) {
            this.page_num = 1
            this.page_sum = val
            this.getData()
        },
        handleCurrentChange (val) {
            if(isNaN(val)) return
            if(val === null) return
            this.page_num = val
            this.getData()
        },
        removeDomain(item) {
            var index = this.addForm.plc_addrs.indexOf(item)
            if (index !== -1) {
                this.addForm.plc_addrs.splice(index, 1)
            }
        },
        removeDomain1(item) {
            var index = this.addPLCForm.plc_addrs.indexOf(item)
            if (index !== -1) {
                this.addPLCForm.plc_addrs.splice(index, 1)
            }
        },
        addDomain() {
            this.addForm.plc_addrs.push({
                addr: '',
                name: '',
                type: '',
            });
        },
        addDomain1() {
            this.addPLCForm.plc_addrs.push({
                addr: '',
                name: '',
                type: '',
            });
        },
        async handleToSet() {
            let res = await Service.getPlcterminalbasicByPID({terminal_id: this.oid})
            if(res) {
                this.dialogFormVisible1 = true
                if(res.oid) {
                    this.addPLCForm.oid = res.oid
                    this.addPLCForm.plc_addrs = res.plc_addrs
                }else{
                    this.addPLCForm.terminal_id = this.oid;
                }
            }
        },
        handleSave1() {
            this.$refs['addPLCForm'].validate(async (valid) => {
                if (valid) {
					// this.addPLCForm.plc_addrs.map(v=>{
					// 	v.is_swap = JSON.parse(v.is_swap)
					// })
					// this.addPLCForm.plc_addrs[0].is_swap = JSON.parse(this.addPLCForm.plc_addrs[0].is_swap)
                    let plc_addrs = JSON.stringify(this.addPLCForm.plc_addrs)
                    let params = Object.assign({}, this.addPLCForm, {plc_addrs})
                    let res
                    if(this.addPLCForm.oid) {
                        // 编辑
                        res = await Service.editPlcterminalbasicByPID(params)
                    }else{
                        // 新增
                        res = await Service.addPlcterminalbasicByPID(params)
                    }
                    if(res) {
                        this.$message({
                            type: 'success',
                            message: '操作成功!'
                        });
                        this.dialogFormVisible1 = false;
                        this.getData();
                    }
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        // 导出
        async handleExport() {
            let terminal_id = this.oid;
            let res = await Service.getPlcExport({terminal_id})
            if(res) {
                location.href = config.DEFAULT_FILE_PATH + res
            }
        },
        // 导出模板
        async handleExportMode() {
            location.href = "/导入配置模板.xlsx"
        },
        // 导入
        async handleAvatarSuccess(res) {
            if(res.status == 20001000) {
                let terminal_id = this.oid;
                let res1 = await Service.getPlcImport({terminal_id, file_path: res.data})
                if(res1) {
                    this.$message.success("操作成功");
                    this.getData()
                }
            }else{
                this.$message.error(res.message);
            }
        },
        uploadVideoProcess(event, file, fileList){
            this.videoUploadPercent = file.percentage.toFixed(0);
        },
        // 上传
        beforeAvatarUpload(file) {
            const Xls = file.name.split('.');
            const isLt2M = file.size / 1024 / 1024 < 2;
            if(Xls[1] === 'xls'|| Xls[1] === 'xlsx'){
                return file;
            }else{
                this.$message.error('上传文件只能是 xls/xlsx 格式')
                return false
            }
            if (!isLt2M) {
                this.$message.error("上传文件大小不能超过 2MB!");
            }
            return isLt2M;
        },
    }
}

</script>
<style lang='less' scoped>

</style>